import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
//import { EndScreen } from './EndScreen';
import GameSceneBase from './GameSceneBase';
import { OnboardingPointer } from '../../display/ui/OnboardingPointer';

const ITEMS = [
  [
    { costume: 'base_apple', score: 1 },
    { costume: 'base_coconut', score: 0 },
    { costume: 'base_tennis', score: -1 },
  ],
  [
    { costume: 'filling_peanut', score: 1 },
    { costume: 'filling_butter', score: 0 },
    { costume: 'filling_chocolate', score: -1 },
  ],
  [
    { costume: 'sprinkles_insects', score: 1 },
    { costume: 'sprinkles_sugar', score: 0 },
    { costume: 'sprinkles_sprinkles', score: -1 },
  ],
  [
    { costume: 'topping_seeds', score: 1 },
    { costume: 'topping_bugs', score: 0 },
    { costume: 'topping_bread', score: -1 },
  ],
];

const ONBOARDING = {
  items: [
    { x: 550, y: 500 },
    { x: 840, y: 500 },
    { x: 1130, y: 500 },
  ],
  confirm: [{ x: 1075, y: 150 }],
};

export default class FeedTheBirds extends GameSceneBase {
  constructor() {
    super({ key: KEYS.FeedTheBirds, active: false });
  }

  create() {
    super.create();

    this.spineBG = this.add.spine(840, 360, 'feed_the_birds_background', '', true);

    this.onboardingPointer = new OnboardingPointer(this, {
      tapPositions: ONBOARDING.items,
    }).setDepth(1);

    this.setupGame();
  }

  setupGame() {
    this.spineBG.once('complete', this.showInstruction, this);
    this.spineBG.setAnimation(0, 'intro', false);
    this.spineBG.on('event', this.handleSpineEvent, this);

    this.leftSelect = this.add.spine(540, 360, 'feed_the_birds_select', '', true);
    this.midSelect = this.add.spine(840, 360, 'feed_the_birds_select', '', true);
    this.rightSelect = this.add.spine(1140, 360, 'feed_the_birds_select', '', true);

    this.confirm = this.add.spine(840, 360, 'feed_the_birds_confirm', '', true);
    this.chosen = this.add.spine(840, 360, 'feed_the_birds_chosen', '', true);

    this.confirm.setAnimation(0, 'off', true);
    this.chosen.visible = false;

    this.itemsChosen = [];
    this.itemScores = [];
    this.selectedSide = null;
    this.selectedItem = null;
    this.selectedItemScore = 0;

    this.setItems();
    this.disallowSelection();

    this.leftSelect.setAnimation(0, 'intro', false);
    this.midSelect.setAnimation(0, 'intro', false);
    this.rightSelect.setAnimation(0, 'intro', false);
  }

  showInstruction() {
    super.showInstruction(this.game.copy.get('FeedTheBirds_instruction'), this.setItems, this);
  }

  setItems() {
    const itemsToChoose = [...ITEMS[this.itemsChosen.length]];
    itemsToChoose.sort((a, b) => Math.random() < 0.5);

    this.leftSelect.currentItem = itemsToChoose[0];
    this.midSelect.currentItem = itemsToChoose[1];
    this.rightSelect.currentItem = itemsToChoose[2];

    this.setItem('left', this.leftSelect.currentItem);
    this.setItem('mid', this.midSelect.currentItem);
    this.setItem('right', this.rightSelect.currentItem);
  }

  getObjectBySide(side) {
    switch (side) {
      case 'left':
        return this.leftSelect;
      case 'mid':
        return this.midSelect;
      case 'right':
        return this.rightSelect;
    }
    return null;
  }

  setItem(side, item) {
    this.stopInteractive(side);
    const spine = this.getObjectBySide(side);
    const skin = spine.findSkin('empty');
    skin.clear();
    skin.addSkin(spine.findSkin('selection_disk'));
    if (item) {
      skin.addSkin(spine.findSkin(item.costume));
      this.makeInteractive(side);
    }
    spine.setSkin(skin);
  }

  allowSelection() {
    this.makeInteractive('left');
    this.makeInteractive('mid');
    this.makeInteractive('right');
    this.onboardingPointer.enable();
  }

  disallowSelection() {
    this.stopInteractive('left');
    this.stopInteractive('mid');
    this.stopInteractive('right');
    this.onboardingPointer.disable();
  }

  makeInteractive(side) {
    const obj = this.getObjectBySide(side);
    if (obj.rect) return;
    const rect = this.add.rectangle(obj.x, obj.y, 200, 200, 0x000000, 0);
    rect.setInteractive({
      useHandCursor: true,
      hitArea: new Phaser.Geom.Rectangle(0, 130, rect.width, rect.height),
      hitAreaCallback: Phaser.Geom.Rectangle.Contains,
    });
    obj.rect = rect;
    rect.on('pointerdown', () => {
      this.updateAudioFX();
      this.itemSelected(side);
    });
  }

  stopInteractive(side) {
    const obj = this.getObjectBySide(side);
    if (obj.rect) {
      obj.rect.removeInteractive();
      obj.rect.off('pointerdown');
      obj.rect.destroy();
      obj.rect = null;
    }
  }

  handleSpineEvent(t, e) {
    if (e.data?.name === 'sfx') {
      switch (e.stringValue) {
        case 'page_open':
          this.game.soundController.playSFX('general', 'general_page_open');
          break;
        case 'page_close':
          this.game.soundController.playSFX('general', 'general_page_close');
          break;
        case 'page_popup':
          this.game.soundController.playSFX('general', 'general_popup');
          break;
      }
    }
  }

  startGame() {
    this.spineBG.setAnimation(0, 'idle', true);
    this.leftSelect.setAnimation(0, 'idle', true);
    this.midSelect.setAnimation(0, 'idle', true);
    this.rightSelect.setAnimation(0, 'idle', true);

    this.allowSelection();
  }

  itemSelected(side) {
    const obj = this.getObjectBySide(side);
    if (this.selectedItem == null) {
      if (this.itemsChosen.length == 0) {
        this.chosen.visible = true;
        this.chosen.setAnimation(0, 'in', false);
      } else {
        this.chosen.setAnimation(0, 'bounce', false);
      }
      this.confirm.once('complete', () => {
        this.confirm.setAnimation(0, 'idle', true);
        this.onboardingPointer.setTapPositions(ONBOARDING.confirm);
        const rect = this.add.rectangle(1080, 160, 150, 150, 0x000000, 0);
        rect.setInteractive({
          useHandCursor: true,
          hitArea: new Phaser.Geom.Rectangle(0, 0, rect.width, rect.height),
          hitAreaCallback: Phaser.Geom.Rectangle.Contains,
        });
        this.confirm.rect = rect;
        rect.on('pointerdown', () => {
          this.updateAudioFX();
          this.confirmItem();
        });
      });
      this.confirm.setAnimation(0, 'in', false);
    } else {
      const prev = this.getObjectBySide(this.selectedSide);
      this.setItem(this.selectedSide, prev.currentItem);
      this.chosen.setAnimation(0, 'bounce', false);
    }
    this.selectedSide = side;
    this.selectedItem = obj.currentItem.costume;
    this.selectedItemScore = obj.currentItem.score;
    obj.setAnimation(0, 'bounce', false);

    this.costumeName = obj.currentItem.costume.split('_').pop();

    if (
      this.costumeName === 'peanut' ||
      this.costumeName === 'chocolate' ||
      this.costumeName === 'butter'
    ) {
      this.spreadsFX = this.game.soundController.playSFX('feedthebirds', 'feed_spreads');
    } else {
      this.feedFX = this.game.soundController.playSFX('feedthebirds', 'feed_' + this.costumeName);
    }

    this.setItem(side, null);

    this.drawRopeItem();
  }

  confirmItem() {
    // this.chosen.setAnimation(0, 'bounce', false);
    this.itemsChosen.push(this.selectedItem);
    this.itemScores.push(this.selectedItemScore);
    this.selectedSide = null;
    this.selectedItem = null;
    this.selectedItemScore = 0;
    this.confirm.rect?.destroy();

    this.confirm.once('complete', () => {
      this.confirm.setAnimation(0, 'off', false);
    });
    this.confirm.setAnimation(0, 'interact', false);
    this.game.soundController.playSFX('feedthebirds', 'feed_button');

    this.disallowSelection();
    if (this.itemsChosen.length == ITEMS.length) {
      this.leftSelect.once('complete', () => {
        this.leftSelect.visible = false;
        this.midSelect.visible = false;
        this.rightSelect.visible = false;
        const stars = this.calculateStars();
        if (stars >= 2) {
          this.winGame(stars);
        } else {
          this.loseGame(stars);
        }
      });
    } else {
      this.leftSelect.once('complete', () => {
        this.onboardingPointer.setTapPositions(ONBOARDING.items);
        this.leftSelect.once('complete', () => {
          this.allowSelection();
        });
        this.leftSelect.setAnimation(0, 'in', false);
        this.midSelect.setAnimation(0, 'in', false);
        this.rightSelect.setAnimation(0, 'in', false);
        this.setItems();
      });
    }
    this.leftSelect.setAnimation(0, 'out', false);
    this.midSelect.setAnimation(0, 'out', false);
    this.rightSelect.setAnimation(0, 'out', false);
  }

  updateAudioFX() {
    this.game.soundController.stopAllSFX();
  }

  calculateStars() {
    let good = 0;
    let neutral = 0;
    let bad = 0;
    this.itemScores.forEach((e) => {
      if (e == -1) {
        bad++;
      } else if (e == 0) {
        neutral++;
      } else if (e == 1) {
        good++;
      }
    });
    if (bad == 0 && neutral == 0) {
      return 3;
    } else if (bad == 0) {
      return 2;
    } else if (good > 0 || neutral > 0) {
      return 1;
    } else {
      return 0;
    }
  }

  drawRopeItem() {
    const skin = this.chosen.findSkin('empty');
    skin.clear();
    this.itemsChosen.forEach((e) => {
      skin.addSkin(this.chosen.findSkin(e));
    });
    skin.addSkin(this.chosen.findSkin(this.selectedItem));
    this.chosen.setSkin(skin);
  }

  winGame(stars) {
    this.updateAudioFX();
    this.game.soundController.stopMusic('music');
    this.disallowSelection();
    this.spineBG.once('complete', () => {
      this.showEndGameScreen(true, stars);
    });

    this.spineBG.setAnimation(0, 'win', false);
    this.chosen.once('complete', () => {
      this.chosen.visible = false;
    });
    this.game.soundController.playSFX('general', 'general_success', {
      delay: 1.2,
    });
    this.game.soundController.playSFX('feedthebirds', 'feed_birds', { delay: 2.2 });
    this.chosen.setAnimation(0, 'out', false);
  }

  loseGame(stars) {
    this.updateAudioFX();
    this.game.soundController.stopMusic('music');
    this.disallowSelection();
    this.spineBG.once('complete', () => {
      this.showEndGameScreen(false, stars);
    });

    this.spineBG.setAnimation(0, 'lose', false);
    this.chosen.once('complete', () => {
      this.chosen.visible = false;
    });
    this.game.soundController.playSFX('general', 'general_fail', {
      delay: 1.2,
    });
    this.game.soundController.playSFX('feedthebirds', 'feed_pecking', { delay: 1.5 });
    this.game.soundController.playSFX('feedthebirds', 'feed_fall', { delay: 2.2 });
    this.chosen.setAnimation(0, 'out', false);
  }

  //showEndGameScreen(win, stars) {
  // this.game.model.setStars(KEYS.FeedTheBirds, stars);
  //   this.endScreen = new EndScreen(this, { win, stars });
  //   this.endScreen.on('CONTINUE', this.nextGame, this);
  //   this.endScreen.on('RESTART', this.restartGame, this);
  // }

  nextGame() {
    this.scene.game.soundController.playMusic('music');
    this.endScreen?.destroy();
    this.endScreen = null;

    this.leftSelect?.destroy();
    this.midSelect?.destroy();
    this.rightSelect?.destroy();
    this.confirm?.destroy();
    this.chosen?.destroy();
    this.leftSelect = null;
    this.midSelect = null;
    this.rightSelect = null;
    this.confirm = null;
    this.chosen = null;

    this.game.loadGame(KEYS.KeepOutTheCold, 'energy'); // TODO
  }

  restartGame() {
    this.endScreen?.destroy();
    this.endScreen = null;

    this.leftSelect?.destroy();
    this.midSelect?.destroy();
    this.rightSelect?.destroy();
    this.confirm?.destroy();
    this.chosen?.destroy();
    this.leftSelect = null;
    this.midSelect = null;
    this.rightSelect = null;
    this.confirm = null;
    this.chosen = null;
    this.setupGame();
  }

  shutdown() {
    this.game.soundController.stopAllSFX();
    super.shutdown();
    this.spineBG?.destroy();
    this.leftSelect?.destroy();
    this.midSelect?.destroy();
    this.rightSelect?.destroy();
    this.confirm?.destroy();
    this.chosen?.destroy();
    this.endScreen?.destroy();
    this.endScreen = null;
    this.spineBG = null;
    this.leftSelect = null;
    this.midSelect = null;
    this.rightSelect = null;
    this.confirm = null;
    this.chosen = null;
    this.game.unloadGame(KEYS.FeedTheBirds);
  }
}
